import React, { Profiler } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/login';
import Dashboard from './pages/dashobard';
import TransactionMobileRecharge from './pages/transaction/mobile-dth';
import TransactionBillPayment from './pages/transaction/bill-payment';
import TransactionPending from './pages/transaction/pending';
import TransactionPayment from './pages/transaction/payment';
import TransactionAllPayment from './pages/transaction/all-payment';
import AllUsers from './pages/users/all';
import Tickets from './pages/ticket';
import MarginPlan from './pages/margin/plan';
import Margin from './pages/margin/setup';
import Providers from './pages/api/provider';
import Balance from './pages/api/balance';
import Operators from './pages/setting/operator';
import Banners from './pages/setting/banner';
import ProviderSetup from './pages/api/provider-setup';
import ServiceProvider from './pages/setting/service-provider';
import KhatabookParty from './pages/khatabook/party';
import KhatabookBank from './pages/khatabook/bank';
import KhatabookPayment from './pages/khatabook/payment';
import TransactionLedger from './pages/transaction/ledger';
import Notification from './pages/notification';
import Profile from './pages/profile';
import Support from './pages/support';
import Theme from './pages/theme';
import LiveTransaction from './pages/transaction/live';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/transaction/mobile-dth" element={<TransactionMobileRecharge />} />
      <Route path="/transaction/bill-payment" element={<TransactionBillPayment />} />
      <Route path="/transaction/pending" element={<TransactionPending />} />
      <Route path="/transaction/payment" element={<TransactionPayment />} />
      <Route path="/transaction/all-payment" element={<TransactionAllPayment />} />
      <Route path="/transaction/ledger" element={<TransactionLedger />} />
      <Route path="/transaction/live" element={<LiveTransaction />} />
      <Route path="/users/all" element={<AllUsers />} />
      <Route path="/ticket" element={<Tickets />} />
      <Route path="/margin/plan" element={<MarginPlan />} />
      <Route path="/margin/setup" element={<Margin />} />
      <Route path="/api/providers" element={<Providers />} />
      <Route path="/api/provider-setup" element={<ProviderSetup />} />
      <Route path="/api/balance" element={<Balance />} />
      <Route path="/setting/operator" element={<Operators />} />
      <Route path="/setting/banner" element={<Banners />} />
      <Route path="/setting/service-provider" element={<ServiceProvider />} />
      <Route path="/khatabook/party" element={<KhatabookParty />} />
      <Route path="/khatabook/bank" element={<KhatabookBank />} />
      <Route path="/khatabook/payment" element={<KhatabookPayment/>} />
      <Route path="/notification" element={<Notification/>} />
      <Route path="/profile" element={<Profile/>} />
      <Route path="/support" element={<Support/>} />
      <Route path="/theme" element={<Theme/>} />
    </Routes>
  </BrowserRouter>
);
reportWebVitals();
